import React from 'react'
import ClientsGraphics from '../components/graphics/Clients'
import UsersGraphics from '../components/graphics/Users'
import ReservationsGraphics from '../components/graphics/Reservations'
import ConfigurationSection from '../components/graphics/Configuration'
import { Grid } from '@mui/material';

const MonthlyGraphics = () => {
  return (
    <>
      <Grid container sx={{ justifyContent: 'space-around', textAlign: 'center', textTransform: 'capitalize' }}>
        <Grid item xs={5} sx={{ pb: 10 }}>
          <ClientsGraphics />
        </Grid>
        <Grid item xs={5} sx={{ pb: 10 }}>
          <UsersGraphics />
        </Grid>

        <Grid item xs={12}>
        <h2 style={{ fontFamily: 'Roboto-Thin' }}>Reporte general</h2>
        </Grid>

        <Grid item xs={6} sx={{ pb: 10 }}>
          <ConfigurationSection month={0} />
        </Grid>

        <Grid item xs={6} sx={{ pb: 10 }}>
          <ConfigurationSection month={1} />
        </Grid>

        <Grid item xs={6} sx={{ pb: 10 }}>
          <ConfigurationSection month={2} />
        </Grid>

        <Grid item xs={6} sx={{ pb: 10 }}>
          <ConfigurationSection month={3} />
        </Grid>

        <Grid item xs={6} sx={{ pb: 10 }}>
          <ConfigurationSection month={4} />
        </Grid>

        <Grid item xs={6} sx={{ pb: 10 }}>
          <ReservationsGraphics />
        </Grid>
      </Grid>
    </>
  )
}

export default MonthlyGraphics